// Playground glass-pwa only (techrepair-glass / Hosting site glass-pwa).
// Stock CRA/Workbox skipWaiting runs only on a SKIP_WAITING message. clients.claim
// on activate is not enough — an old controller can linger after a hard-refresh
// and serve the prior precache on the next navigation (classic residual:
// footer OK, then /app/orders?jobsSot=handoff paints the previous bake stamp).

export const PLAYGROUND_SKIP_WAITING_MESSAGE = { type: 'SKIP_WAITING' } as const;

type WaitingWorker = {
    postMessage: (message: unknown) => void;
};

let playgroundReloadArmed = false;

export function resetPlaygroundServiceWorkerReloadForTests(): void {
    playgroundReloadArmed = false;
}

export function waitingWorkerFromRegistration(registration: {
    waiting?: WaitingWorker | null;
    installing?: WaitingWorker | null;
}): WaitingWorker | null {
    return registration.waiting || registration.installing || null;
}

export function shouldSkipWaitingPlaygroundWorker(args: {
    hasController: boolean;
    waitingWorker: WaitingWorker | null | undefined;
}): boolean {
    return Boolean(args.hasController && args.waitingWorker);
}

/** Post SKIP_WAITING to the waiting worker and reload once after it claims. */
export function activateWaitingPlaygroundWorker(args: {
    hasController: boolean;
    waitingWorker: WaitingWorker | null | undefined;
    addControllerChangeListener: (listener: () => void) => void;
    reload: () => void;
}): boolean {
    if (!shouldSkipWaitingPlaygroundWorker(args) || !args.waitingWorker) {
        return false;
    }

    if (!playgroundReloadArmed) {
        playgroundReloadArmed = true;
        let refreshing = false;
        args.addControllerChangeListener(() => {
            if (refreshing) {
                return;
            }
            refreshing = true;
            args.reload();
        });
    }

    args.waitingWorker.postMessage(PLAYGROUND_SKIP_WAITING_MESSAGE);
    return true;
}
